<template>
  <div ref="intsllationDetailTemplates">
    <div v-if="showRadioButtons">
      <div v-for="(option, index) in data.answerOptions" :key="index">
        <ejs-radiobutton
          :label="option.item"
          :name="radioBtnName"
          :checked="data.answerValue === option.item"
          @change="onChange(option.item, data.workListId)"
          :value="data.answerValue"
        />
      </div>
    </div>
    <div v-else>
      <ejs-dropdownlist
        :dataSource="data.answerOptions"
        sortOrder="Ascending"
        float-label-type="Always"
        :showClearButton="true"
        :fields="{ value: 'item' }"
        :value="data.answerValue"
        @change="onChange($event.value, data.workListId)"
      />
    </div>
    <label v-if="showValidation" class="e-error">This field is required</label>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'RadioButtonTemplate',
  data() {
    return {
      data: {},
    };
  },
  computed: {
    yesLabel() {
      return this.data.answerOptions[0].item;
    },
    showValidation() {
      return (this.data.answerValue == null || this.data.answerValue === undefined);
    },
    noLabel() {
      return this.data.answerOptions[2].item;
    },
    notApplicableLabel() {
      return this.data.answerOptions[1].item;
    },
    radioBtnName() {
      return `${this.data.question}`;
    },
    showRadioButtons() {
      return (
        this.yesLabel === 'Yes'
        && this.noLabel === 'No'
        && this.notApplicableLabel === 'N/A'
      );
    },
    ...mapGetters({
      applicationWorkLists: 'applicationWorkLists',
    }),
  },
  methods: {
    onChange(val, workListId) {
      const updatedItem = this.applicationWorkLists.find(
        (x) => x.workListId === workListId,
      );
      // eslint-disable-next-line no-multi-assign
      this.data.answerValue = updatedItem.answerValue = val;
    },
  },
};
</script>
